import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { Box, Container } from "@mui/material";
import { useEffect } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useLocation } from "react-router-dom";
import { useIntercom } from "react-use-intercom";
import { AuthenticatedRoutes, UnAuthenticatedRoutes } from "./Routes";
import { DRAWER_WIDTH, Sidebar } from "./components/shared/Sidebar";
import { NotAuthorized } from "./pages/not-authorized/NotAuthorized";
import { useConfig } from "./utils/useConfig";
import { useFeatures } from "./utils/useData";

function App() {
  const { config } = useConfig();
  const location = useLocation();
  const { isLoading: isFeaturesLoading, data: features } = useFeatures();

  const { boot } = useIntercom();

  const { isAuthenticated, isLoading, error, login, getPermission } =
    useKindeAuth();

  useEffect(() => {
    // Don't force re-dir to login if on onboarding route
    if (isAuthenticated || isLoading || location.pathname === "/onboarding")
      return;
    login &&
      login({
        app_state: {
          redirectTo: window.location.pathname
        }
      });
  }, [isAuthenticated, isLoading, location.pathname, login]);

  useEffect(() => {
    boot();
  }, [boot]);

  if (isLoading || isFeaturesLoading) return <p>Loading...</p>;

  if (error) return <p>{error}</p>;

  // Self-Service Onboarding - Requires Feature enabled + ReCaptcha API key
  if (
    !isAuthenticated &&
    features?.find(
      (f) => f.name === "self-service-onboarding" && f.isEnabled
    ) &&
    config?.GOOGLE_RECAPTCHA_SITE_KEY
  ) {
    return (
      <Box minHeight="100%">
        <GoogleReCaptchaProvider
          reCaptchaKey={config.GOOGLE_RECAPTCHA_SITE_KEY}
        >
          <UnAuthenticatedRoutes />
        </GoogleReCaptchaProvider>
      </Box>
    );
  }

  const isAuthorized = getPermission("employer_access").isGranted;

  if (!isAuthorized) return <NotAuthorized />;

  return (
    <>
      <Sidebar />
      <Box
        component={"main"}
        sx={{
          width: `calc(100% - ${DRAWER_WIDTH}px)`,
          flexGrow: 1,
          p: { xs: 2, sm: 3 },
          overflowX: "auto",
          marginLeft: `${DRAWER_WIDTH - 24}px`
        }}
      >
        <Container
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column"
          }}
          maxWidth="lg"
        >
          <AuthenticatedRoutes />
        </Container>
      </Box>
    </>
  );
}

export default App;
